export default "__VITE_ASSET__DIycXzWk__"